module.exports = __webpack_public_path__ + "static/img/img.de1a3cdb.svg";